// Section 9 and 12: Clinic. 12 build points, 8 wood and 8 stone; healers treat 6 instead of 3;
// +15 medicine capacity; contagion 0.7x. Limit 1 per 50 people. Constants: config.buildings.clinic.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  capacityHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function clinic(config: Config) {
  const c = config.buildings.clinic;

  return defineBuilding({
    id: 'clinic',
    label: 'Clinic',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'stone',
    beds: 0,
    plots: 0,
    capacity: { medicine: c.medicineCapacity },
    limit: { kind: 'per-people', people: c.peoplePerClinic },
    modifierTargets: ['capacity', 'output', 'illnessRisk', 'buildingEffect'],
    modifierKeys: { output: ['healer'] },
    modifiers: combineModifiers(
      buildingEffectHook('clinic'),
      capacityHook('clinic', { medicine: c.medicineCapacity }),
      (ctx, target) => {
        const e = Math.min(1, effective(ctx, 'clinic'));
        if (e <= 0) return [];
        const h = config.jobs.healer;
        if (target.kind === 'output' && target.jobId === 'healer') {
          return [
            mod.mul('building:clinic', 1 + (h.treatsWithClinic / h.treats - 1) * e, 'clinic'),
          ];
        }
        if (target.kind === 'illnessRisk')
          return [mod.mul('building:clinic', 1 - (1 - c.contagion) * e, 'contagion')];
        return [];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
